const handleOptionClick = (setEnteredValue, setSuggestedValue, setIsNavigated, setOff, onSelection) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const value = e.target.value;
    setEnteredValue(value);
    setSuggestedValue(value);
    onSelection && onSelection(value);
    setOff();
    setIsNavigated(false);
};
export default handleOptionClick;
//# sourceMappingURL=handleOptionClick.js.map